import { ICellRendererParams } from "ag-grid-community";
import { AgentAttributeValueModel, ProfileApiModel } from "src/shared/models/dashboard.model";
import { LoginApiModel } from "src/shared/models/login.model";
import { IEventEmitter } from "src/shared/models/shared-event-emitter";
import { Group } from "../Models/group.model";

export enum AssignmentPermissions {
    None = 'None',
    Read = 'Read', 
    ReadTheirs = 'ReadTheirs',
    ReadGroup = 'ReadGroup', 
    ReadControl = 'ReadControl',
    Write = 'Write', 
    WriteTheirs = 'WriteTheirs',
    Template = 'Template'
}
export enum AssignmentPermissionIndex {
    Read,
    ReadTheirs,
    ReadGroup, 
    ReadControl,
    Write,
    WriteTheirs,
    Template
}

export type AssignmentSelection = AgentAttributeValueModel | LoginApiModel | Group;

export interface DashboardPermissionsCellRendererParams extends ICellRendererParams {
    permissionChanged?: IEventEmitter<AssignmentPermissions>;
}

export interface IAssignmentWithProfiles {
    profiles: Map<number, AssignmentProfile>;
}

export class AssignmentGroup implements IAssignmentWithProfiles {
    profiles = new Map<number, AssignmentProfile>();
    constructor(public group: Group) { }
}

export class AssignmentAttribute implements IAssignmentWithProfiles {
    profiles: Map<number, AssignmentProfile> = new Map();
    constructor(public attribute: AgentAttributeValueModel) { }
}

export interface AssignmentProfile {
    profile: ProfileApiModel;
    permission: AssignmentPermissions;
}

export interface AssignmentLogins {
    login: LoginApiModel;
    permission: AssignmentPermissions;
}

export class AssignmentChanges {
    groups: Map<number, AssignmentGroup> = new Map();
    logins: Map<number, AssignmentLogins> = new Map();
    attributes: Map<number, AssignmentAttribute> = new Map();
}

export class AssignmentLists {
    items = new AssignedItems();
    constructor(public title: string, public permission: AssignmentPermissions) { }
}

export class AssignedItems {
    logins: LoginApiModel[] = [];
    groups = new Map<number, AssignedGroupItems>();
    attributes = new Map<number, AssignedAttributeItems>();
}

export class AssignedGroupItems {
    roles: ProfileApiModel[] = [];
    constructor(public group: Group = null) { }
}

export class AssignedAttributeItems {
    roles: ProfileApiModel[] = [];
    constructor(public attribute: AgentAttributeValueModel = null) { }
}

export interface DashboardAssignmentChangesModel {
    isLogin: boolean;
    permission: AssignmentPermissions;
    id: number;
    companyID?: number;
    groupID?: number;
    groupLevel?: number;
    baseGroupType?: number;
    userAttributeID?: number;
}

export interface DashboardPermissionsCellRendererParams extends ICellRendererParams {
    permissionChanged?: IEventEmitter<AssignmentPermissions>;
}

export interface IAssignmentWithProfiles {
    profiles: Map<number, AssignmentProfile>;
}
